/**
 * @generated SignedSource<<f698263b5ee5a6e03bbf997226089316>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type sprintField_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly selectedSprintsConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly sprints: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string | null;
        readonly sprintId: string;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "sprintField_updateWorkItemAllFieldTypesActionRenderer";
};
export type sprintField_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: sprintField_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"sprintField_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sprintAris"
    }
  ],
  "kind": "Fragment",
  "name": "sprintField_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    (v0/*: any*/),
    {
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "selectedSprintsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "args": [
        {
          "fields": [
            {
              "kind": "Literal",
              "name": "operation",
              "value": "ALLOW"
            },
            {
              "kind": "Variable",
              "name": "optionIds",
              "variableName": "sprintAris"
            }
          ],
          "kind": "ObjectValue",
          "name": "filterById"
        }
      ],
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "sprints",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "sprintId"
                },
                (v0/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSprintField"
};
})();

(node as any).hash = "9575e235ecac91131bd2985a846a65c9";

export default node;
